import React from 'react'

const WaitForm = () => {
	return (
		<></>
	)
}

export default WaitForm
